import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateSearchComponent } from './template-search.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [TemplateSearchComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class TemplateSearchModule { }
